import { Clear } from '@mui/icons-material'
import { Button, ButtonGroup } from '@mui/material'
import { useSearch } from '@/features/search/hooks/useSearch'
import { useAppSelector } from '@/redux/hooks'

export default function ManageSelection() {
  const { selectors, clearSelection } = useSearch()
  const selection = useAppSelector(selectors.selectCurrentSelectionRows)

  const handleClear = () => clearSelection()
  const disabled = selection.length === 0

  return (
      <ButtonGroup disabled={disabled} variant="text" color="info">
        <Button>{selection.length} Items Selected</Button>
        <Button title="Clear selection" onClick={handleClear}>
          <Clear fontSize={'small'} />
        </Button>
      </ButtonGroup>
  )
}
